import { render, staticRenderFns } from "./editPurchaseOrder.vue?vue&type=template&id=4facf05a&scoped=true"
import script from "./editPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./editPurchaseOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4facf05a",
  null
  
)

export default component.exports